import { useCallback } from 'react';
import { useClient } from 'urql';

import fetchQuery from '@/helper/data-op/fetchQuery';
import useDefaultErrorSnackbar from '@/hooks/useDefaultErrorSnackbar';
import { SelectGroupsInput } from '@/types/schema';

import { SelectGroupsDocument, SelectGroupsQuery } from '../graphql/queries/generated/selectGroup';

export default function useSelectedGroups() {
  const client = useClient();
  const { showDefaultErrorSnackbar } = useDefaultErrorSnackbar();

  const fetchSelectedGroupIds = useCallback(
    async (input: SelectGroupsInput) => {
      const { error, data } = await fetchQuery<SelectGroupsQuery>(
        client,
        SelectGroupsDocument,
        {
          input,
        },
        {},
      );

      if (error) {
        showDefaultErrorSnackbar();
        return;
      }

      return data?.selectGroups?.groupIds;
    },
    [client, showDefaultErrorSnackbar],
  );

  return {
    fetchSelectedGroupIds,
  };
}
